<ng-container *ngrxLet="vm$ as vm" class="form-container">
  <form [formGroup]="form" class="form">
    <ng-container formGroupName="assessmentMetadata">
      <div class="form-row">
        <div class="column terra-body">
          <div class="label terra-body">Choose {{ vm.language.survey.item }}</div>
          <nty-select
            formControlName="assessmentDefinitionId"
            [showModalTitle]="true"
            [error]="hasRequiredError(form.get('assessmentMetadata')?.get('assessmentDefinitionId')) && isSubmitted"
            placeholder="Choose your {{ vm.language.survey.item }}"
            [modalHeight]="0.33"
            [disabled]="form.controls.assessmentMetadata.controls.assessmentDefinitionId.disabled">
            <ng-container modalTitle>Select your {{ vm.language.survey.item }}</ng-container>
            @for (assessmentDefinition of vm.assessmentDefinitions; track assessmentDefinition.assessmentDefinitionId) {
              <nty-option
                class="create-assessment-definition-option"
                [value]="assessmentDefinition.assessmentDefinitionId">
                {{ assessmentDefinition.name }}
              </nty-option>
            }
          </nty-select>
          @if (hasRequiredError(form.get('assessmentMetadata')?.get('assessmentDefinitionId')) && isSubmitted) {
            <nty-form-error>Select your Assessment</nty-form-error>
          }
        </div>
      </div>

      <div class="form-row">
        <div class="column">
          <nty-title
            formControlName="name"
            placeholder="Title your {{ vm.language.survey.item }}"
            [disabled]="form.controls.assessmentMetadata.controls.name.disabled" />
          @if (hasRequiredError(form.get('assessmentMetadata')?.get('name')) && isSubmitted) {
            <nty-form-error>Give your Assessment a name.</nty-form-error>
          }
        </div>
      </div>

      <div class="form-row description-row">
        <div class="column">
          <nty-description
            formControlName="description"
            placeholder="Add a description {{
              isOptional(form.controls['assessmentMetadata'].controls['description']) ? '(optional)' : ''
            }}"
            [disabled]="form.controls.assessmentMetadata.controls.description.disabled" />
        </div>
      </div>

      <div class="form-row bty-body">
        <div class="column">
          <div class="label terra-body">Owner</div>
          <div class="owner">
            <div>
              <nty-user-avatar
                [size]="'24px'"
                fontSize="10px"
                [userInitials]="vm.user?.initials ?? ''"
                [avatarUrl]="vm.user?.avatarUrl ?? ''" />
              {{ vm.user | userName }}
            </div>
            <ion-icon src="assets/icons/caret-down--regular.svg" />
          </div>
        </div>
      </div>

      <div class="form-row date-row terra-body">
        <div class="column-50">
          <div class="label terra-body">Launch Date</div>
          <nty-date-picker
            formControlName="launchDate"
            [minDate]="minLaunchDate$ | async"
            [disabled]="form.controls.assessmentMetadata.controls.launchDate.disabled" />
        </div>
        <div class="column-50">
          <div class="label terra-body">End Date</div>
          <nty-date-picker
            formControlName="endDate"
            [minDate]="minEndDate$ | async"
            [disabled]="form.controls.assessmentMetadata.controls.endDate.disabled" />
        </div>
      </div>
    </ng-container>
    <div class="form-row">
      <div class="column">
        <div class="label terra-body">{{ vm.language.survey.item }} Recipients</div>
        <nty-team-multi-select
          formControlName="teamIds"
          [teams]="vm.teams"
          [modalTitle]="'Choose ' + vm.language.survey.recipients"
          [disabled]="form.controls.teamIds.disabled"
          [error]="hasRequiredError(form.get('teamIds')) && isSubmitted"
          [placeholder]="'Choose ' + vm.language.todo.team + '(s)'"
          [ntyIcon]="'users-three--regular.svg'" />
        @if (hasRequiredError(form.get('teamIds')) && isSubmitted) {
          <nty-form-error>Select recipients</nty-form-error>
        }
      </div>
    </div>

    <div class="form-row checkbox-labels">
      <div class="column terra-body">
        <ion-checkbox
          labelPlacement="end"
          [disabled]="form.controls.createTodos.disabled"
          formControlName="createTodos">
          Create {{ vm.language.todo.items }} for {{ vm.language.survey.item }} recipients
        </ion-checkbox>
      </div>
      <div class="column checkbox-sublabel terra-body-small">
        Checking this box will create a {{ vm.language.todo.item }} for each {{ vm.language.survey.recipients }} on the
        {{ vm.language.todo.team }} the {{ vm.language.survey.item }} is sent to.
      </div>
    </div>

    <div class="form-row">
      <div class="column">
        <div class="label terra-body">{{ vm.language.survey.item }} Report Recipients</div>
        <nty-team-multi-select
          formControlName="sendReportToUserIds"
          [teams]="vm.teams"
          [modalTitle]="'Choose ' + vm.language.survey.recipients"
          [placeholder]="'Choose ' + vm.language.survey.recipients + ' of completed reports'"
          [ntyIcon]="'users-three--regular.svg'" />
      </div>
    </div>
  </form>
</ng-container>
